import { render, staticRenderFns } from "./bruno-giacosa.vue?vue&type=template&id=12ff7f03&scoped=true"
import script from "./bruno-giacosa.vue?vue&type=script&lang=js"
export * from "./bruno-giacosa.vue?vue&type=script&lang=js"
import style0 from "./bruno-giacosa.vue?vue&type=style&index=0&id=12ff7f03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff7f03",
  null
  
)

export default component.exports